export default "__VITE_PUBLIC_ASSET__1e10103d__"